import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'

export function writeWorkspace<T>(
  ctx: Pick<FlashcardsFeRouterCtx, 'writes' | 'afterCommit' | 'afterLocalCommit'>,
  workspaceId: string,
  commit: () => PromiseLike<T>,
): Promise<T> {
  return ctx.writes.run(async () => {
    const result = await commit()
    if (ctx.afterLocalCommit) await ctx.afterLocalCommit(workspaceId)
    else await ctx.afterCommit(workspaceId)
    return result
  })
}
